export const environment = {
  busqueda :  '###FICHERO_CONFIGURACION_FRONT###',
  
  production: false,
  baseURL: 'http://localhost:9998/',
  //baseURL: 'https://geshdadweb.com:9998/',
  baseURLsage: 'http://localhost:9998/',
 // baseURLsage: 'https://geshdadweb.com:9998/',
  imagenLogin: 'assets/images/login-background.jpg',
  imagenEscudo: 'assets/images/titulo.jpg',
  imagenHome: 'assets/images/fondo_home.jpg',
 
  //Limite de tamaño para las llamadas a la api, evita errores en el servidor
  //baseURL: 'http://127.0.0.1:9999/',
  //baseURLsage: 'http://127.0.0.1:9999/',

  size_api_limit: 100
};
